import { Injectable } from '@angular/core';
import { SlWapiService } from './sl-wapi.service';
import { ICancellablePromise, CancellablePromise } from 'src/app/types/cancellable-promise';
import { LayerTypeEnum, LayerGeomtypes, SLLayer } from '../sl-layer';



export interface ILayerViewOwner {
	id: string | number;
	user_name: string;
	name: string;
	tally: number;
}

export interface ILayerViewGroup {
	id: string | number;
	name: string;
	tally: number;
}
export interface ILayerViewTag {
	tag: string;
	tally: number;
}

export interface ILayerViewLayer {
	id: string;
	name: string;
	type: number;
	description: string;
	geom: string;
	icon?: string;
	fontIcon?: string;
	hasFontIcon?: boolean;
	share_level: number;
}

export interface ILayerView {
	name: string;
	label: string;
	wapi: string;
	options?: Array<ILayerViewOwner> | Array<ILayerViewGroup>;
}

@Injectable({
	providedIn: 'root'
})
export class LayerViewsService {

	constructor(private wapi: SlWapiService) { }

	ListViews(): ICancellablePromise {
		return this.wapi.Post('layers/views/list/', {}, true);
	}
	GetViewLayers(view: ILayerView, subItem?: ILayerViewOwner | ILayerViewGroup | ILayerViewTag) {
		const params = view.wapi.match(/\[^\]+\]/gi);
		let url = view.wapi;
		for (const param of params) {
			const paramName = param.replace(/[\[\]]/g, '');
			if (subItem.hasOwnProperty(paramName)) {
				url = url.replace(param, subItem[paramName]);
			}
		}
		return this.wapi.Post(url, {});
	}

}
